import { Component } from '@angular/core';

@Component({
  selector: 'app-refund-policy-page',
  templateUrl: './refund-policy-page.component.html',
  styleUrls: ['./refund-policy-page.component.css']
})
export class RefundPolicyPageComponent {

}
